<template>
  <div class="lp-child-base basic-input" :style="styles">
    <block-title :target-info="targetInfo" :color-scheme="colorScheme" />
    <block-fortune-input
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :action="action"
      :method="method"
      :token="token"
      :lp-id="lpId"
      pageLabel="basicinput"
    />
<!--    <block-banner v-if="showBanner" />-->
  </div>
</template>

<script>
import BlockTitle from '@/utvStore/components/recommend/lp/blocks/BlockTitle'
import BlockFortuneInput from './blocks/BlockFortuneInput'
// import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'

export default {
  name: 'BasicInput',
  components: {
    BlockTitle,
    BlockFortuneInput,
    // BlockBanner,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    token: {
      type: String,
      default: '',
    }
  },
  data(){
    return {
      action: `/recommend/lp/${this.lpId}/basic/action`,
      method: 'post',
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    showBanner() {
      return true
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  font-family: "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic Pro", "source-han-sans-japanese", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #32373F;
  /*
  .block-title {
    background: #FFEDFA;
  }
   */
  background: url(/static/img/recommend/lp/ottimo/fotune_bg1.png);
  background-size: 15px 15px;
  margin: 0 auto;
  width: 100%;
  max-width: 580px;

  /deep/ {
    .basic-block {
      background: transparent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/BasicInput.vue